export const GET_VIDEOS_REQUEST = "GET_VIDEOS_REQUEST";
export const GET_VIDEOS_SUCCESS = "GET_VIDEOS_SUCCESS";
export const GET_VIDEOS_ERROR = "GET_VIDEOS_ERROR";
export const GET_VIDEOS_DONE = "GET_VIDEOS_DONE";

export const ADD_VIDEOS_REQUEST = "ADD_VIDEOS_REQUEST";

export const UPDATE_VIDEOS_REQUEST = "UPDATE_VIDEOS_REQUEST";

export const DELETE_VIDEO_REQUEST = "DELETE_VIDEO_REQUEST";

export const INCREMENT_VIDEO_INDEX_REQUEST = "INCREMENT_VIDEO_INDEX_REQUEST";
export const DECREMENT_VIDEO_INDEX_REQUEST = "DECREMENT_VIDEO_INDEX_REQUEST";

export const getVideosRequest = (payload) => ({
  type: GET_VIDEOS_REQUEST,
  ...payload,
});

export const getVideosSuccess = (videos) => ({
  type: GET_VIDEOS_SUCCESS,
  videos,
});

export const getVideosError = (error) => ({
  type: GET_VIDEOS_ERROR,
  error,
});

export const getVideosDone = () => ({
  type: GET_VIDEOS_DONE,
});

export const addVideosRequest = (videos) => ({
  type: ADD_VIDEOS_REQUEST,
  videos,
});

export const updateVideoRequest = (video, data) => ({
  type: UPDATE_VIDEOS_REQUEST,
  video,
  data,
});

export const deleteVideoRequest = (video) => ({
  type: DELETE_VIDEO_REQUEST,
  video,
});

export const incrementVideoIndexRequest = (video) => ({
  type: INCREMENT_VIDEO_INDEX_REQUEST,
  video,
});

export const decrementVideoIndexRequest = (video) => ({
  type: DECREMENT_VIDEO_INDEX_REQUEST,
  video,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/actions.js